// Copyright (c) StrangeBee 2024

import React, { ReactElement } from 'react';
import { THForm } from '@Molecules/THForm/THForm';
import { THInput } from '@Molecules/Inputs/THInput/THInput';
import { THSelect } from '@Molecules/Inputs/THSelect/THSelect';
import { THSwitch } from '@Molecules/Inputs/THSwitch/THSwitch';
import { useLocalMessage } from '@Helpers/locale';
import { THPassword } from '@Molecules/Inputs/THPassword/THPassword';

const nameKey = {
    ldap: {
        hosts: ['hosts'],
        useSSL: ['useSSL'],
        bindDN: ['bindDN'],
        bindPW: ['bindPW'],
        baseDN: ['baseDN'],
        filter: ['filter'],
    },
};

export const resetFields = {
    hosts: [],
    useSSL: false,
    bindDN: '',
    bindPW: '',
    baseDN: '',
    filter: '',
};

const ConfigLDAP = ({ availableProviders = [] }: { availableProviders?: string[] }): ReactElement => {
    const local = useLocalMessage();

    const notAvailable = !availableProviders?.includes('ldap');

    return (
        <>
            <THForm.Item
                name={nameKey.ldap.hosts}
                label={local('configPlateform.ldap.hosts')}
                rules={[{ required: true }]}
            >
                <THSelect mode="tags" disabled={notAvailable} />
            </THForm.Item>
            <THForm.Item
                name={nameKey.ldap.useSSL}
                label={local('configPlateform.ldap.useSSL')}
                valuePropName="checked"
            >
                <THSwitch disabled={notAvailable} />
            </THForm.Item>
            <THForm.Item
                name={nameKey.ldap.bindDN}
                label={local('configPlateform.ldap.bindDN')}
                rules={[{ required: true }]}
            >
                <THInput disabled={notAvailable} />
            </THForm.Item>
            <THForm.Item
                name={nameKey.ldap.bindPW}
                label={local('configPlateform.ldap.bindPW')}
                rules={[{ required: true }]}
            >
                <THPassword disabled={notAvailable} />
            </THForm.Item>
            <THForm.Item
                name={nameKey.ldap.baseDN}
                label={local('configPlateform.ldap.baseDN')}
                rules={[{ required: true }]}
            >
                <THInput disabled={notAvailable} />
            </THForm.Item>
            <THForm.Item
                name={nameKey.ldap.filter}
                label={local('configPlateform.ldap.filter')}
                rules={[{ required: true }]}
            >
                <THInput placeholder="(uid={0})" disabled={notAvailable} />
            </THForm.Item>
        </>
    );
};

export default ConfigLDAP;
